// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as HyperLogger$OrcaPaymentPage from "./hyper-log-catcher/HyperLogger.bs.js";
import * as UtilityHooks$OrcaPaymentPage from "./Hooks/UtilityHooks.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "./Utilities/PaymentHelpers.bs.js";

function Redsys3ds(props) {
  var logger = HyperLogger$OrcaPaymentPage.make(undefined, {
        TAG: "Elements",
        _0: "Payment"
      }, undefined, undefined, undefined);
  var isCompleteAuthorizeCalledRef = React.useRef(false);
  var timeoutRef = React.useRef(undefined);
  var eventsToSendToParent = [
    "confirmParams",
    "poll_status",
    "openurl_if_required"
  ];
  var completeAuthorize = PaymentHelpers$OrcaPaymentPage.useRedsysCompleteAuthorize(logger);
  var handleCompleteAuthorizeCall = function (threeDsMethodComp, clientSecret, publishableKey, headers, returnUrl, sdkAuthorization) {
    isCompleteAuthorizeCalledRef.current = true;
    var body = [[
        "threeds_method_comp_ind",
        threeDsMethodComp
      ]];
    if (sdkAuthorization === "") {
      body.push([
            "client_secret",
            clientSecret
          ]);
    }
    completeAuthorize(undefined, body, {
          return_url: returnUrl,
          publishableKey: publishableKey
        }, "redsys3ds", clientSecret, headers, sdkAuthorization);
  };
  UtilityHooks$OrcaPaymentPage.useSendEventsToParent(eventsToSendToParent);
  React.useEffect((function () {
          Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                  "iframeMountedCallback",
                  true
                ]]);
          var handle = function (ev) {
            try {
              var json = Utils$OrcaPaymentPage.safeParse(ev.data);
              var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
              if (!Core__Option.isSome(dict["fullScreenIframeMounted"])) {
                return ;
              }
              var metadata = Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "metadata");
              var metaDataDict = Core__Option.getOr(Core__JSON.Decode.object(metadata), {});
              var clientSecret = Utils$OrcaPaymentPage.getString(metaDataDict, "clientSecret", "");
              var publishableKey = Utils$OrcaPaymentPage.getString(metaDataDict, "publishableKey", "");
              var sdkAuthorization = Utils$OrcaPaymentPage.getString(metaDataDict, "sdkAuthorization", "");
              logger.setClientSecret(clientSecret);
              logger.setSdkAuthorization(sdkAuthorization);
              logger.setMerchantId(publishableKey);
              var headersDict = Utils$OrcaPaymentPage.getDictFromDict(metaDataDict, "headers");
              var headers = Utils$OrcaPaymentPage.convertDictToArrayOfKeyStringTuples(headersDict);
              var confirmParam = Utils$OrcaPaymentPage.getDictFromObj(metaDataDict, "confirmParams");
              var returnUrl = Utils$OrcaPaymentPage.getString(confirmParam, "return_url", "");
              var iframeDataDict = Utils$OrcaPaymentPage.getDictFromObj(metaDataDict, "iframeData");
              var methodKey = Utils$OrcaPaymentPage.getString(iframeDataDict, "method_key", "threeDSMethodData");
              var threeDsMethodUrl = Utils$OrcaPaymentPage.getString(iframeDataDict, "three_ds_method_url", "");
              var threeDsMethodData = Utils$OrcaPaymentPage.getString(iframeDataDict, "three_ds_method_data", "");
              var threeDsIframe = document.querySelector("#threeDsAuthFrame");
              var elem = document.querySelector("#threeDsDiv");
              if (!(elem == null) && threeDsMethodUrl !== "") {
                var form = Utils$OrcaPaymentPage.makeForm(elem, threeDsMethodUrl, "threeDsHiddenPostMethod");
                var input = document.createElement("input");
                input.name = encodeURIComponent(methodKey);
                input.value = encodeURIComponent(threeDsMethodData);
                form.target = "threeDsAuthFrame";
                form.appendChild(input);
                form.submit();
              }
              Core__Option.forEach(timeoutRef.current, (function (prim) {
                      clearTimeout(prim);
                    }));
              timeoutRef.current = Caml_option.some(setTimeout((function () {
                          handleCompleteAuthorizeCall("N", clientSecret, publishableKey, headers, returnUrl, sdkAuthorization);
                        }), 10000));
              if (!(threeDsIframe == null)) {
                threeDsIframe.addEventListener("load", (function (param) {
                        Core__Option.forEach(timeoutRef.current, (function (prim) {
                                clearTimeout(prim);
                              }));
                        if (!isCompleteAuthorizeCalledRef.current) {
                          handleCompleteAuthorizeCall("Y", clientSecret, publishableKey, headers, returnUrl, sdkAuthorization);
                          return ;
                        }
                        
                      }));
                return ;
              } else {
                return ;
              }
            }
            catch (exn){
              return Utils$OrcaPaymentPage.postFailedSubmitResponse("complete_authorize_failed", "Something went wrong.");
            }
          };
          window.addEventListener("message", handle);
          return (function () {
                    window.removeEventListener("message", handle);
                    Core__Option.forEach(timeoutRef.current, (function (prim) {
                            clearTimeout(prim);
                          }));
                  });
        }), []);
  return React.createElement("div", {
              className: "max-w-1 max-h-1 opacity-0 fixed left-[-9999px]",
              id: "threeDsDiv"
            }, React.createElement("iframe", {
                  id: "threeDsAuthFrame",
                  title: "3D Secure Authentication Frame",
                  name: "threeDsAuthFrame"
                }));
}

var make = Redsys3ds;

export {
  make ,
}
/* react Not a pure module */
